// Re-export getRoleLabel from centralized i18n/helpers module
export { getRoleLabel } from '../i18n/helpers';

const USER_ROLES = ['owner', 'hr_admin', 'manager', 'employee'] as const;

export type UserRole = (typeof USER_ROLES)[number];

export function isUserRole(value: unknown): value is UserRole {
  return typeof value === 'string' && USER_ROLES.includes(value as UserRole);
}

/** @deprecated Use getRoleLabel() instead for i18n support */
const ROLE_LABELS: Record<UserRole, string> = {
  owner: 'Owner',
  hr_admin: 'HR Admin',
  manager: 'Manager',
  employee: 'Employee'
};

export { USER_ROLES, ROLE_LABELS };
